import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-4xl font-semibold">404</h1>
      <p className="text-muted-foreground">{t("This page doesn't exist.")}</p>
      <Button asChild>
        <Link to="/patients">{t('Back to patients')}</Link>
      </Button>
    </div>
  );
}
